"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TapeBuilderRecordDBSchema = exports.TapeBuilderRecordUISchema = exports.DbNodes = void 0;
// export everything for now
__exportStar(require("./tape-builder-base"), exports);
const DbNodes = __importStar(require("../dbNodes/dbNodesTypes"));
exports.DbNodes = DbNodes;
const v4_1 = require("zod/v4");
const rawRecordSchema = v4_1.z.discriminatedUnion('type', [
    DbNodes.rawLoanTape.NodeTypeSchema,
    DbNodes.rawCashBalanceFeed.NodeTypeSchema,
    DbNodes.rawRepaymentTape.NodeTypeSchema,
    DbNodes.rawSupplementalTape.NodeTypeSchema,
    DbNodes.rawReceivableDocumentation.NodeTypeSchema,
    DbNodes.rawZipTape.NodeTypeSchema,
]);
const commonRecordSchema = v4_1.z.discriminatedUnion('type', [
    rawRecordSchema,
    DbNodes.configTape.NodeTypeSchema,
    DbNodes.dataLakeTape.NodeTypeSchema,
    DbNodes.forwardedTape.NodeTypeSchema,
    DbNodes.directInsertPortfolioCovenant.NodeTypeSchema,
    DbNodes.directInsertPortfolioCovenants.NodeTypeSchema,
    DbNodes.directInsertFinancialCovenants.NodeTypeSchema,
    DbNodes.fundingRequest.NodeTypeSchema,
    DbNodes.generatedCashBalanceFeed.NodeTypeSchema,
    DbNodes.generatedCovenantLoanTape.NodeTypeSchema,
    DbNodes.generatedFinancialData.NodeTypeSchema,
    DbNodes.generatedLoanTape.NodeTypeSchema,
    DbNodes.generatedRepaymentTape.NodeTypeSchema,
    DbNodes.generatedSupplementalTape.NodeTypeSchema,
    DbNodes.finStatement.NodeTypeSchema,
    DbNodes.intermediateTape.NodeTypeSchema,
    DbNodes.limitedPartnersTape.NodeTypeSchema,
    DbNodes.orgProvidedInput.NodeTypeSchema,
    DbNodes.orgProvidedInputs.NodeTypeSchema,
    DbNodes.receivableInvoice.NodeTypeSchema,
    DbNodes.receivableResponseTape.NodeTypeSchema,
    DbNodes.valleyBankIngest.NodeTypeSchema,
    DbNodes.valleyBankSlsIngest.NodeTypeSchema,
    DbNodes.valleyBankSlsCommitment.NodeTypeSchema,
    DbNodes.uploadToDatalake.NodeTypeSchema,
    DbNodes.waitForDataLakeTable.NodeTypeSchema,
]);
exports.TapeBuilderRecordUISchema = v4_1.z.discriminatedUnion('type', [
    commonRecordSchema,
    DbNodes.assignedRepaymentTape.IntermediateNodeSchema,
    DbNodes.borrowingBaseReport.IntermediateNodeSchema,
    DbNodes.directInsertBorrowingBaseReport.IntermediateNodeSchema,
]);
exports.TapeBuilderRecordDBSchema = v4_1.z.discriminatedUnion('type', [
    commonRecordSchema,
    DbNodes.assignedRepaymentTape.NodeTypeSchema,
    DbNodes.userInputNeeded.NodeTypeSchema,
    DbNodes.masterLoanTape.NodeTypeSchema,
    DbNodes.assignedLoanTape.NodeTypeSchema,
    DbNodes.manualBankAccountReport.NodeTypeSchema,
    DbNodes.cashBalancesFeedContext.NodeTypeSchema,
    DbNodes.cashResponseTape.NodeTypeSchema,
    DbNodes.receivableResponseTapePreview.NodeTypeSchema,
    DbNodes.borrowingBaseReport.NodeTypeSchema,
    DbNodes.directInsertBorrowingBaseReport.NodeTypeSchema,
    DbNodes.fundingVerificationReport.NodeTypeSchema,
    DbNodes.fundingApprovalReport.NodeTypeSchema,
    DbNodes.receivableDocumentationVerificationReport.NodeTypeSchema,
    DbNodes.internalRepaymentTape.NodeTypeSchema,
]);
//# sourceMappingURL=tape-builder.js.map